<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">
					
					<div class="user_menu">
						<div class="item" @click="open(item)" :class="{'active':menu_id == item.id}"
							v-for="(item, index) in menu">
							{{item.name}}
						</div>

					</div>
				</div>
				<div class="fr">


					<div class="user_center">

						<div class="user_de_ti" style="margin-bottom: 30px;">我的收藏</div>

						<div class="user_page_list">
							<ul class="shoucang_list">

								<li @click="$router.push('/goodsdetail?id='+item.ar_id)" v-for="(item, index) in list"
									class="t-flex ">
									<div class="image">
										<img :src="fixImageUrl(item.image)">
									</div>
									<div class="text">
										<p class="p1">{{item.title}}</p>
										<p class="p12">{{item.daqu_name}}-{{item.server_name}}</p>
										<p class="p2">￥{{item.price}}</p>
									</div>
								</li>
							</ul>

							<div class="page_fenye" v-if="pagination.total > 0">
								<el-pagination background layout="prev, pager, next" :total="pagination.total"
									:page-size="pagination.per_page" @current-change="handleCurrentChange">
								</el-pagination>
							</div>
						</div>

					</div>



				</div>
			</div>
		</div>
	</div>

</template>


<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	import moment from 'moment';
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title: "",
				info: {},

				menu_id: 2,
				menu: [{
						id: 1,
						name: "基本资料",
						url: "/user"
					},
					{
						id: 7,
						name: "实名认证",
						url: "/shiming"
					},
					{
						id: 2,
						name: "我的收藏",
						url: "/shoucang"
					},
					// {
					// 	id: 3,
					// 	name: "我发布的账号",
					// },
					{
						id: 6,
						name: "我的订单",
						url: "/order"
					},
					{
						id: 4,
						name: "修改密码",
						url: "/editpass"
					},
					{
						id: 5,
						name: "退出登录",
					}
				],
				page: 1,
				list: [],
				pagination: {
					total: 0,
					per_page: 0,
				},
				pass: "",
				pass1: "",
				pass2: ""

			}
		},
		computed: {
			userinfo() {
				return this.$store.getters.userinfo
			}
		},
		created: function(data) {
			this.getShouCang()
			// this.getDetail();


		},
		watch: {
			$route() {

			}
		},
		methods: {
			formatTimestamp(timestamp) {
				return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
			},
			open(item) {
				if (item.id == 5) {
					localStorage.removeItem('usertoken')
					sessionStorage.removeItem('usertoken')
					localStorage.setItem('path', this.$route.path)
					this.$router.push("/")
				} else {

					this.$router.push(item.url)
				}
			},
			handleCurrentChange(val) {
				this.page = val
				this.getShouCang()


			},
			getShouCang() {
				var that = this
				this.rq.requests.post("api/game/user/sc", {
					page: that.page
				}).then(res => {

					that.list = res.data.data
					that.pagination.total = res.data.total
					that.pagination.per_page = res.data.per_page
					that.page++

				}).catch(error => {

				})

			},

		}


	}
</script>